import { render, staticRenderFns } from "./group_points.vue?vue&type=template&id=b317b93e&scoped=true"
import script from "./group_points.vue?vue&type=script&lang=js"
export * from "./group_points.vue?vue&type=script&lang=js"
import style0 from "./group_points.vue?vue&type=style&index=0&id=b317b93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b317b93e",
  null
  
)

export default component.exports